import Vue from 'vue';
import Vuex from 'vuex';
import modal from './modules/modal';
import chat from './modules/chat';
import information from './modules/information';
import school from './modules/school';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    modal,
    chat,
    school,
    information
  },
  strict: true
});
